import { BsExclamationSquareFill } from 'react-icons/bs';
import './InputError.scss';

interface IProps {
  children?: any;
}

const InputError: React.FC<IProps> = ({ children }) => {
  return (
    <div className="input-error">
      <div className="input-error-icon">
        <BsExclamationSquareFill />
      </div>
      <div className="input-error-text">{children ?? ''}</div>
    </div>
  );
};

export default InputError;
